module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKcAAAAFCAQAAACKyzSCAAAAT0lEQVQ4Ee3BwRWDIAAFsL9IBfZfofpkkEo7SXpwA7ySJFEcSpYHbHYliWrgUrJM8vLBZYvudmaZ5O22R/PDV8sySTEw1CSarmZ5QNXV5A8kEEKyvI4K1AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/fork_spoon_flyer_diamonds_wide.png
// module id = 1576
// module chunks = 1